import { CachePersistor, LocalForageWrapper } from 'apollo3-cache-persist';
import ApolloCache from 'ApolloCache';
import * as localforage from 'localforage';

const persistor = new CachePersistor({
  cache: ApolloCache,
  storage: new LocalForageWrapper(localforage),
  debug: process.env.REACT_APP_ENVIRONMENT === 'development',
  trigger: 'write',
  maxSize: 1024 * 1024 * 20, // 20MB
});

export const clearApolloCache = () => persistor.purge();
